import React, {useState,useEffect,useRef,useContext,useReducer} from 'react'

import { CONSTANTS, TIME_FRAME_VALUES,OF_TIME_FRAME_VALUES,BOOKMARK_CATEGORY_AUTOSAVE, USER_RESOURCES_LIST, TRADING_TIME_START_LIMIT, TRADING_TIME_END_LIMIT, REPLAY_SPEED, REPLAY_BUCKET_SIZE, PREVIEW_ENDED } from '../../common/utility/constant'
import OFChartHeaderSettings from './components/ofchart_header';
import { Divider } from '@mui/material';
import MPChartRightPanel from './components/mpchart_right_panel';
import MPChartFooter from './components/mpchart_footer';
import { useAxiosWithAuth } from '../../common/api/hooks/useAxiosWithAuth';
import { URL } from '../../common/api/urls';
import useAuth from '../../common/hooks/useAuth';
import { syncTosNotifyFromStatus } from '../../common/utility/tosNotify';
import useSyncUidataNotifyFlags from '../../common/hooks/useSyncUidataNotifyFlags';
// ============================================================
// NEW - Role-based Permission System
// See: src/common/utility/roleController.js
// ============================================================
import { useRoleController } from '../../common/utility/roleController';
// ============================================================
// NEW - Centralized Permission Service
// See: src/common/hooks/usePermissions.js
// ============================================================
import usePermissions from '../../common/hooks/usePermissions';
import { ROLES } from '../../common/utility/roleConstants';
import { USER_ROLE_FIELDS,MP_CHART_RELOAD_TIME,DEFAULT_OF_TIME_FRAME } from '../../common/utility/constant';
import { CircularProgress } from '@mui/material';
import { TEXT_MSGS,SNACKBAR_AUTO_HIDE_DURATION } from '../../common/utility/constant';
import {Snackbar, Alert} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { formatDatesToISO, useQuery } from '../../common/utility/helperFunc';
import { UserSettingsContext } from '../../setup/routes-manager/RequireAuth'
import { VA_TYPE,VP_TYPE } from '../../common/utility/mp_chart_constants';
import { CHART_TYPE } from '../../common/utility/mp_chart_constants';
import LineChart from './line_chart';
import StockChartHV from './stock_chart_hv';
import BarChart from './bar_chart';
import ConfirmActionDialog from './components/confirm_dialog';
import {useSearchParams} from 'react-router-dom';
import PRICE_TABLE from './components/price_table';
import OFChartFooter from './components/ofchart_footer';
import OFChart from './components/orderflow_chart';
import ChartContainer from './chart_container';
import BarChartContainer from './BarChartContainer';
import LineChartContainer from './LineChartContainer';
import useMediaQuery from '@mui/material/useMediaQuery';
import OFSettings from './components/of_settings';
import LineChartContainerNew from './LineChartContainerNew';
import dayjs from "dayjs";
import { PreviewEndModal } from './components/of_preview_ended_popup';
import AppErrorPopup from '../../components/AppErrorPopup';




const DEFAULT_PROFILE_WIDTH=60;
const DEFAULT_PROFILE_WIDTH_WEEKLY=100;
const DEFAULT_PROFILE_WIDTH_MONTHLY=120;
const DEFAULT_PROFILE_WIDTH_YEARLY=400;
const PROFILE_LOAD_FACTOR=1.2;



const OrderflowContainer = (props) => {
  
  // console.log("props==========================>",props);
  const [tabData,setTabData]=useState(props?.tabData??undefined)
  const [initialData,setInitialData]=useState((props?.tabData?.data?.[props.val] &&props?.tabData?.data?.[props.val].type) ?props?.tabData?.data?.[props.val]: undefined)
  const { auth, setAuth } = useAuth();
  // ============================================================
  // NEW - Role-based Permission System
  // See: src/common/utility/roleController.js
  // ============================================================
  const roleController = useRoleController();
  
  // ============================================================
  // NEW - Centralized Permission Service
  // See: src/common/hooks/usePermissions.js
  // ============================================================
  const permissions = usePermissions();
  
  // ============================================================
  // NEW - Role-based elite user check
  // See: src/common/utility/roleController.js
  // ============================================================
  const isEliteUser = permissions.isEliteUser();
  
  const location = useLocation();
  const [chartType, setChartType] = useState(initialData?.type ?? props.chartType ?? CHART_TYPE.OF_CHART);
  // const [chartType, setChartType] = useState(initialData?.type ?? CHART_TYPE.OF_CHART);
  // const [chartType, setChartType] = useState(CHART_TYPE.MARKET_PROFILE);
  const { userSettings, setUserSettings,UIData } = useContext(UserSettingsContext);
  const syncApiNotifyFlags = useSyncUidataNotifyFlags();
  const [ignored, forceUpdate] = useReducer(x => x + 1, 0);
  // const from = location.state?.from?.pathname || "/login";
  const from = "/login";
  const symbol = useQuery("symbol");
  console.log("props.key 1=",props.key,props.val,props.symbol)
  const [state, setState] = useState({
    isLoading:true,
    liveData:undefined,
    chartData:undefined,
    instrument:initialData?.instrument??(props.symbol?props.symbol:(symbol&&props.val==0?symbol:userSettings.data.default_instrument_of?userSettings.data.default_instrument_of:userSettings.data.default_instrument)),
    // instrument:symbol&&props.val==0?symbol:userSettings.data.default_instrument,
    isIncrementalData:false,
    lastLoadTime:-1,
    isInstrumentLive:false,
    // Updated to use centralized permission service instead of old FAST_DATA role check
    reloadInerval: permissions.getChartReloadInterval(),
    pollingInterval:MP_CHART_RELOAD_TIME.POLLING_TIME,
    refreshInterval:-1,
    selectedTimeFrame:initialData?.tf??userSettings?.data?.default_tf_of??DEFAULT_OF_TIME_FRAME,
    isPollingAllowed:false,
    isTradingSessionActive:false,
    isJsonLoaded:false,
    isFirtLoadComplete:false,
    apiData:undefined,
    bookmarkData:undefined,
    isStatusCheckAllowed:false,
    statusCheckPollingInterval:MP_CHART_RELOAD_TIME.POLLING_TIME,
    isLivePollingAllowed:false,
    lastTime:undefined,
    selectedDateTime:null,
    selectedDateTimeLiveFlag:false,
    liveDate:null,
    liveTime:null,
  
  });

  const [footerLoaded,setFooterLoaded]=useState(false);
  
const [msgState, setMsgState] = useState({
  open: false,
  msg:"" ,
  severity:"info"
});

const { open, msg, severity } = msgState;

  const {isLoading,chartData,liveData,isIncrementalData,isInstrumentLive,lastLoadTime,reloadInerval,pollingInterval,instrument,refreshInterval,selectedTimeFrame,
    isPollingAllowed,isTradingSessionActive,isJsonLoaded,isFirtLoadComplete,apiData,bookmarkData,isStatusCheckAllowed,statusCheckPollingInterval,isLivePollingAllowed,lastTime,selectedDateTime,liveDate,liveTime } = state;
  const stateRef = useRef(state);
 
  
const [cancel,responseData,error,loaded,reset,executeAPI] = useAxiosWithAuth();
const [cancelLive,responseDataLive,errorLive,loadedLive,resetLive,executeLive] = useAxiosWithAuth();
const [cancelSaved,responseDataSaved,errorSaved,loadedSaved,resetSaved,executeAPISaved] = useAxiosWithAuth();
const [cancelDelete,responseDataDelete, errorDelete, loadedDelete, resetDelete,executeAPIDelete ] = useAxiosWithAuth();
const [cancelStatus,responseDataStatus,errorStatus,loadedStatus,resetStatus,executeAPIStatus] = useAxiosWithAuth();


  const [selectedInstrument,setSelectedInstrument]=useState()
  const selectedInstrumentRef=useRef(selectedInstrument)
  const [selectedTPO,setSelectedTPO]=useState(initialData?.tpo??undefined)
  const [selectedInstrumentData,setSelectedInstrumentData]=useState();
  const [selectedInstrumentTPOData,setSelectedInstrumentTPOData]=useState();
  const [globalVolumeVisible,setGlobalVolumeVisible]=useState(initialData?.glob_vol??(userSettings.data.show_global_vp_of!=undefined?userSettings.data.show_global_vp_of:true));
  const [volumeNumberVisible,setVolumeNumberVisible]=useState(initialData?.glob_num??(userSettings.data.show_global_vp_numbers_of!=undefined?userSettings.data.show_global_vp_numbers_of:false));
  const [onlyVolumeProfile,setOnlyVolumeProfile]=useState(false);
  const [tpoOnVolume,setTpoOnVolume]=useState(false);
  const [perProfilelVolumeVisible,setPerProfileVolumeVisible]=useState(false);
  const [perProfileVolumeNumberVisible,setProfileVolumeNumberVisible]=useState(false);
  const matches = useMediaQuery('(min-width:820px)');
  const [livePanelVisible,setLivePanelVisible]=useState((matches?true:false)&&(initialData?.live_panel??(userSettings.data.show_live_panel_of!=undefined?userSettings.data.show_live_panel_of:true)));
  const [bottomTableVisible,setBottomTableVisible]=useState(initialData?.table??(userSettings.data.show_bottom_table_of!=undefined?userSettings.data.show_bottom_table_of:true));
  const navigate = useNavigate(); 
  const [autoCenter, setAutocenter] = useState(false);
  // const [viewState, setViewState] = React.useState({tpo_only:true,vol_tpo_side:false,only_vol:false,tpo_on_vol:false});
  const [viewState, setViewState] = React.useState({tpo_only:(userSettings.data.vp_type==VP_TYPE.NONE||userSettings.data.vp_type==VP_TYPE.BACKGROUND),vol_tpo_side:(userSettings.data.vp_type==VP_TYPE.ASIDE),only_vol:(userSettings.data.vp_type==VP_TYPE.ALONE),tpo_on_vol:(userSettings.data.vp_type==VP_TYPE.BACKGROUND)})
 
  const [tpoBasedVA,setTPOBasedVA]=useState(userSettings.data.va_type==VA_TYPE.TPO_BASED);
  const [toggleReset,setToggleReset]=useState(false);
  const [toggleUnselect,setToggleUnselect]=useState(false);
  const [rightPanelConatinerState,setRightPanelConatinerState]=useState({
    show:false,
    metadata:undefined,
    histoticalData:undefined,
    selectedIndexes:[],
    isLiveSession:false
  })
  const [toggleSave,setToggleSave]=useState(false);
  const [toggleSaveBookmark,setToggleBookmark,]=useState(false);
  const [jsonData,setJsonData]=useState();
  const [vpType,setVPType]= React.useState(userSettings.data.vp_type);
  const [stateData,setStateData]=useState();
  const [previewTime,setPreviewTime]=useState(null);
  const [isPreview,setIsPreview]=useState(false);
  const [openAutosaveDeleteDialog,setOpenAutosaveDeleteDialog]=useState(false);
  const [reloadInstrument,setReloadInstrument]=useState();
  const [isDirty,setIsDirty]=useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [toggleMPLoading,setToggleMPLoading]=useState(false);
  const [showTable,setShowTable]=useState(false);
  const [tableData,setTableData]=useState(false);
  const [levelData,setLevelData]=useState([-1,-1]);
  const [showSettings,setShowSettings]=useState(false);
  const [showPreviewEndedPopup, setShowPreviewEndedPopup] = useState(false);

  // Add volx toggle state
  const [volxLinesToggleEnabled,setVolxLinesToggleEnabled]=useState(() => {
    // Always inherit from LVO setting if available, regardless of chart type
    if (userSettings.data["lvo_visibility_ntm_volx"] !== undefined) {
      const lvoValue = userSettings.data["lvo_visibility_ntm_volx"];
      return lvoValue; // Always inherit from LVO setting
    }
    return false; // Default to OFF only if LVO setting is not available
  });
  
  // Track current pathname for proper toggle state updates
  const [currentPathname, setCurrentPathname] = useState(window.location.pathname);
  const [chartLoaded,setChartLoaded]=useState(false);
  // const UIData=JSON.parse(localStorage.getItem("UIData"));
  const tradeDates=formatDatesToISO(UIData.ofTradeDates);
  const [isDatePickerOpen,setIsDatePickerOpen]=useState(false);
  const [replayState,setReplayState]=useState({isReplay:false,date:null,interval:REPLAY_SPEED.DEFAULT});
  const [chartDateList,setChartDateList]=useState(undefined);
  const [bucketSize,setBucketSize]=useState(REPLAY_BUCKET_SIZE.DEFAULT);
  const [toggleRefresh,setToggleRefresh]=useState(undefined)
  const [toggleState,setToggleState]=useState(true);
  const lastReplayTriggerTime = useRef(0); // Track last trigger time to prevent rapid re-triggers
 
  
  useEffect(()=>{
    console.log("DateTest container of=",UIData,UIData.ofTradeDates)
    console.log("Reload props OF container==",globalVolumeVisible,props,initialData,initialData?.instrument,instrument,initialData?.tf,selectedTimeFrame,selectedTPO);
    console.log("ISSUEOF chartype =",chartType,initialData,props.chartType)
    if(props.setChartType)
    props.setChartType(chartType);
    
     const timeout = setTimeout(() => {
        setChartLoaded(true)
        // setTabData(undefined);
        // setInitialData(undefined);
        console.log("Reload props OF container setInitialData=undefined"); 
    }, 1000);
    return () => {
      // just to clear the timeout when component unmounts
      console.log("ISSUEOF unmount is called")
      clearTimeout(timeout)
    }
  },[])

  // Handle replay mode from sidebar navigation (?mode=replay)
  // Wait for BOTH replay mode AND isJsonLoaded before auto-opening
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const replayMode = params.get('mode');
    
    if (replayMode === 'replay' && isJsonLoaded) {
      const now = Date.now();
      const timeSinceLastTrigger = now - lastReplayTriggerTime.current;
      
      // Skip if triggered within last 800ms (prevents duplicate handling)
      if (timeSinceLastTrigger < 800) {
        return;
      }
      
      lastReplayTriggerTime.current = now;
      
      // Force toggle: briefly set to false then true to ensure state change propagates
      const openTimeout = setTimeout(() => {
        setIsDatePickerOpen(false);
        setTimeout(() => {
          setIsDatePickerOpen(true);
        }, 25);
      }, 50);
      
      // Clear URL param after a longer delay to ensure state propagates
      const clearUrlTimeout = setTimeout(() => {
        params.delete('mode');
        const newSearch = params.toString();
        navigate('/orderflow' + (newSearch ? '?' + newSearch : ''), { replace: true });
      }, 600);
      
      return () => {
        clearTimeout(openTimeout);
        clearTimeout(clearUrlTimeout);
      };
    }
  }, [location.search, isJsonLoaded, navigate])
   
  const openStockChart=()=>{
    navigate(`/stock-chart?type=SINGLE&symbol=${selectedInstrument}&startDate=&nDays=0`, { replace: false });   
  }
  useEffect(()=>{
    console.log("ISSUEOF chartype 3=",chartType,initialData,props.chartType)
  },[chartType])

  const openMPChart=()=>{
    console.log("ISSUEOF chartype 1=",chartType,initialData)
    setShowTable(false);
    if(chartType!=CHART_TYPE.MARKET_PROFILE && !isPreview){
      console.log("ISSUEOF chartype 2=",chartType,initialData)
      console.log("live panel resetRightPanel===1")
      props.resetRightPanel(); 
      // console.log("state=",state);
      setPollingAllowedVal(false);
      setChartType(CHART_TYPE.MARKET_PROFILE)
      if(props.setChartType!=undefined)
      props.setChartType(CHART_TYPE.MARKET_PROFILE)
      
      // setState((prevState) => ({
      //   ...prevState,
      //   isLoading:false}));
      
      // setSelectedInstrument(selectedInstrument);
      if(props.setIsDirty){
        props.setIsDirty(true);
      }
      }
    // navigate(`/stock-chart?type=SINGLE&symbol=${selectedInstrument}&startDate=&nDays=0`, { replace: false });   
  }
  // const openMPChart=()=>{
    
  //   // if(chartType!=CHART_TYPE.LINE_CHART){
  //     console.log("ISSUEOF chartype MP1=",chartType,initialData,props.chartType)
  //     console.log("selected instrument",props.val,selectedInstrument);
  //     console.log("live panel resetRightPanel===2")
  //     props.resetRightPanel(); 
  //     setPollingAllowedVal(false)
  //     setStateData(undefined);
  //     setChartType(CHART_TYPE.MARKET_PROFILE)
  //     if(props.setChartType!=undefined){
  //       console.log("ISSUEOF chartype MP1=",chartType,initialData,props.chartType)
  //     props.setChartType(CHART_TYPE.MARKET_PROFILE)
  //     }
  //   // }
  //   // navigate(`/line-chart?type=SINGLE&symbol=${selectedInstrument}&startDate=&nDays=0`, { replace: false });   
  // }

  const setCurrentChartType=(val)=>{
    // props.setParentChartType(val)
  }
  
  const openLineChart=()=>{
    
    // if(chartType!=CHART_TYPE.LINE_CHART){
      console.log("ISSUEOF chartype LC1=",chartType,initialData)
      console.log("selected instrument",props.val,selectedInstrument);
      console.log("live panel resetRightPanel===2")
      props.resetRightPanel(); 
      setPollingAllowedVal(false)
      setStateData(undefined);
      setChartType(CHART_TYPE.LINE_CHART)
      if(props.setChartType!=undefined){
        console.log("ISSUEOF chartype LC1=",chartType,initialData,props.chartType)
      props.setChartType(CHART_TYPE.LINE_CHART)
      }
      if(props.setIsDirty){
        props.setIsDirty(true);
      }
    // }
    // navigate(`/line-chart?type=SINGLE&symbol=${selectedInstrument}&startDate=&nDays=0`, { replace: false });   
  }

  const openOFChart=()=>{
    setShowTable(false);
    if(chartType!=CHART_TYPE.OF_CHART){
      console.log("live panel resetRightPanel===1")
      props.resetRightPanel(); 
      // console.log("state=",state);
      setPollingAllowedVal(false)
      setChartType(CHART_TYPE.OF_CHART)
      if(props.setChartType!=undefined)
      props.setChartType(CHART_TYPE.OF_CHART)
      if(props.setIsDirty){
        props.setIsDirty(true);
      }
     
      }
     
  }

  useEffect(()=>{
    console.log("OF Chart container Props changes, proUser",props.chartStateData,props.proUser)
  },[props.chartStateData])

  
  const loadAutoSaveData=(val)=>{
    console.log("LoadAutsave dat val====",val);
    // executeAPISaved(`${URL.GET_BOOKMARK_DATA}?id=${val}`,"GET",{});
  }

   /**
 * API response handler  auto saved data
 */  
   useEffect(() => {
    if(loadedSaved){
      console.log("loaded Save=true",responseDataSaved);
      if(responseDataSaved!=null){
           console.log("Saved data loaded",responseDataSaved.data)
           const jsonData=responseDataSaved.data.data;
           document.title = "MP Charts - " + jsonData.instrument.replace('O_','');
          //  setJsonData(jsonData);
           let data={
            "symbol": jsonData.instrument,
            "nDays":0,
            "nProf": "",
            // "nProf": 2,
            "dstr": jsonData.dstr,   //
            "liveData": true,
            "liveOnly": false,
            "liveDataComposite": false,
            "startDate":jsonData.startDate,
            // "endDate": "",
            "tf": jsonData.tf,
            "max_cmp_days":parseInt(userSettings.data.max_ndays_for_composite),
            "contracts": userSettings.data.data_in_contracts,
            "upperLevel":(jsonData.upperLevel? jsonData.upperLevel : undefined),
            "lowerLevel":(jsonData.lowerLevel? jsonData.lowerLevel : undefined),
          }
         

          //save the symbol in the url
           if(responseDataSaved.data.category==BOOKMARK_CATEGORY_AUTOSAVE && props.val==0 && !props.isGlobalBookmark)
          setSearchParams({"symbol":jsonData.instrument})
          
          setSelectedTPO(jsonData.tpo);
          let bookmarkData=responseDataSaved.data;
         
          bookmarkData.last_saved=responseDataSaved.last_saved;
          setState((prevState) => ({
            ...prevState,
            isLoading:true,
            isJsonLoaded:true,
            selectedTimeFrame:data.tf,
            apiData:data,
            bookmarkData:responseDataSaved.data,
            selectedInstrument:jsonData.instrument,
            instrument:jsonData.instrument}));
            setJsonData(jsonData);
            setFooterLoaded(true);
            
            if(jsonData.upperLevel && jsonData.lowerLevel){
              let levels=[];
              levels.push(jsonData.upperLevel);
              levels.push(jsonData.lowerLevel);
              setLevelData(levels.sort());
            }
            // if(selectedInstrument!=undefined)
            // executeAPI(URL.MPCHART,"POST",data);
      }
      else if(errorSaved!==null){
        // loadData();
        console.log("Error data=",errorSaved);
        setState((prevState) => ({
          ...prevState,
          isJsonLoaded:true,
          isFirtLoadComplete:true,
          isLoading:false}));
          
          // setMsgState({open:true,msg:errorSaved?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"error"});
          //if unauthorized then redirec it to login page
          if(errorSaved?.response?.status === 401 || errorSaved?.response?.status === 403){
            console.log("status received =",errorSaved?.response?.status)
            navigate(from, { replace: true });
          }else
          setMsgState({open:true,msg:errorSaved?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"error"});
      }
      resetSaved();
    }
    },[loadedSaved,responseDataSaved]);

 const loadData=()=>{
  console.log("loadData selectedTimeFRame=",selectedTimeFrame)
  let nprof=1;//TODO: testing... set it to one in prod
  if(selectedTimeFrame==OF_TIME_FRAME_VALUES.tf_30_min){
    nprof=2;
  }  
  
  // console.log("usersettings=",userSettings.data)
  document.title = "Orderflow Charts - " + selectedInstrument.replace('O_','');
 
  // console.log("chart api data = ",data,selectedInstrument);
  setState((prevState) => ({
    ...prevState,
    isLoading:true,
    chartData:undefined,
    instrument:selectedInstrument}));
  

//   executeAPI(URL.MPCHART,"POST",data);
  let tempData={
    "symbol": selectedInstrument,
    "nProf": nprof,
    "liveData": true,
    "liveOnly": false,
    "startDate": "",
    "endDate": "",
    "tf": selectedTimeFrame,
    "contracts": true
}

   if (selectedDateTime) {
     let startDate = dayjs(selectedDateTime).format("DD-MM-YYYY");
     let time = dayjs(selectedDateTime).format("HH:mm")
     console.log("DateTest tradeDates=", tradeDates, dayjs(tradeDates[0]).format("DD-MM-YYYY"), time, time < TRADING_TIME_START_LIMIT);
    //  if (time < TRADING_TIME_START_LIMIT) {
      if (true) { //always load one previous profile for replay feature left hand data
       let tempDate = dayjs(selectedDateTime).format("YYYY-MM-DD");
       let index = tradeDates.findIndex(item => item === tempDate);
       console.log("DateTest index=", index)
       if (index > 0) {
         startDate = dayjs(tradeDates[index - 1]).format("DD-MM-YYYY")
         nprof = nprof + 1;
       }
     }
     if (time > TRADING_TIME_END_LIMIT) {
       nprof = nprof + 1;
     }

     let liveflag=false;
     console.log("YoyoOF startDate",startDate,tradeDates[tradeDates.length-1])
     let tempDate=dayjs(selectedDateTime).format("YYYY-MM-DD")
     if(tempDate==tradeDates[tradeDates.length-1]){
      console.log("YoyoOF 1")
      liveflag=true;
     }
    else{
      //when live date is selected, startdata=last trade date and live flag =true
      const d1 = new Date((dayjs(selectedDateTime).format("YYYY-MM-DD")));
      const d2 = new Date(tradeDates[tradeDates.length-1]);
     
      if(d1>d2){
        console.log("YOYOOF 2 DateTestNew 12 liveDate is selected")
        liveflag=true;
        startDate=dayjs(tradeDates[tradeDates.length - 1]).format("DD-MM-YYYY")
      }
    }
    
     setState((prevState) => ({
      ...prevState,
      selectedDateTimeLiveFlag:liveflag,
      }));

     console.log("DateTestNew loadchart startDate,lastdate nprof=",startDate,tradeDates[tradeDates.length-1],liveflag)
     tempData = {
       "symbol": selectedInstrument,
       "nProf": nprof,
       "liveData": liveflag,
       "liveOnly": false,
       "startDate": startDate,
       "endDate": "",
       "tf": selectedTimeFrame,
       "contracts": true
     }
     setLivePanelVisible(false);
   }
   if (window.__tfBenchmark) {
       window.__tfBenchmark.apiCallTime = performance.now();
       console.log(
           `[TF_BENCHMARK] ${(
               window.__tfBenchmark.apiCallTime - window.__tfBenchmark.clickTime
           ).toFixed(2)}ms | api_call_start`,
       );
   }

executeAPI(URL.OF_CHART,"POST",tempData);

 }  
 

 
 

  //execute the data fetch on the component mount
  useEffect(()=>{
     setIsDirty(true);
      setJsonData(undefined);
      setState((prevState) => ({
        ...prevState,
        isJsonLoaded:true,
        isFirtLoadComplete:true}));
  },[]);

  useEffect(()=>{
    console.log("OFData useeffect is called for instr and time frame",selectedInstrument, selectedTimeFrame,apiData);
    if(selectedInstrument!=undefined){
      if(props.addSymbol)
        props.addSymbol(selectedInstrument)
     
     
      //save the current symbol in URL if its not in the bookmark view
      if (!searchParams.has('bookmarkID') && props.val==0 && !props.isGlobalBookmark) {
        setSearchParams({"symbol":selectedInstrument})
      }
      // setJsonData(undefined);
      setState((prevState)=>({
        ...prevState,
        // apiData:undefined,
        bookmarkData:undefined,
        // isJsonLoaded:false,
      }))
      setFooterLoaded(true);
      loadData();
      setIsDirty(true);
   
    }
  },[selectedInstrument,selectedTimeFrame,toggleMPLoading,selectedDateTime]);

  

 
  useState(()=>{
    console.log("charttype,state",chartType,state);
  },[state])
  /**
 * API response handler  
 */  
   useEffect(() => {
    if(loaded){
      // responseData=JSON.parse(responseData)
     
      if(responseData!=null){
        // console.log("ofdata loaded=true",responseData,responseData.dateList);
            if(responseData.of_data!==undefined && responseData.of_data.length>0){
              if(window.__tfBenchmark && window.__tfBenchmark.apiCallTime && !window.__tfBenchmark.apiResponseTime){
    window.__tfBenchmark.apiResponseTime = performance.now();
    console.log(`[TF_BENCHMARK] ${(window.__tfBenchmark.apiResponseTime-window.__tfBenchmark.clickTime).toFixed(2)}ms | api_response (network=${(window.__tfBenchmark.apiResponseTime-window.__tfBenchmark.apiCallTime).toFixed(2)}ms)`);
  }

              let updateInterval=pollingInterval;
              if(responseData.isPreOpenLive!=undefined && responseData.isPreOpenLive){
                updateInterval=!selectedInstrumentData.slow?reloadInerval:MP_CHART_RELOAD_TIME.SLOW_DATA;
              }
              // responseData.isTradingSessionActive=true;
              let isLiveDataPresent=(responseData.isInstrumentLive && responseData.dateList.length>0 && responseData.dateList[responseData.dateList.length-1]==responseData.liveDate);
               setState((prevState) => ({
                  ...prevState,refreshInterval:updateInterval,
                  isPollingAllowed:true,
                  isStatusCheckAllowed:(!responseData.isPreOpenLive),
                  statusCheckPollingInterval:(responseData.isTradingSessionActive?MP_CHART_RELOAD_TIME.FAST_POLLING:MP_CHART_RELOAD_TIME.POLLING_TIME),
                  isJsonLoaded:true,
                  isFirtLoadComplete:true,
                  // selectedTimeFrame:(jsonData!=undefined?jsonData.tf:selectedTimeFrame),
                  isTradingSessionActive:responseData.isTradingSessionActive,
                  isLoading:false,
                  isIncrementalData:isLiveDataPresent,
                  liveDate:isLiveDataPresent?responseData.liveDate:responseData.isTradingSessionActive?responseData.dateList[responseData.dateList.length-1]:null,
                  liveTime:isLiveDataPresent?responseData.lastDataTime:responseData.isTradingSessionActive?responseData.lastDataTime:null,
                  isInstrumentLive:(responseData.isPreOpenLive && responseData.dateList.length>0 && responseData.dateList[responseData.dateList.length-1]==responseData.liveDate),
                  isLivePollingAllowed:responseData.isPreOpenLive,
                  chartData:responseData,
                  lastTime:responseData.lastTime?responseData.lastTime:undefined
                }));
                console.log("OFdata api loaded",responseData.of_data);
            }
           
            if(responseData.upgrade_notify!=undefined && responseData.upgrade_notify && !(responseData.preview === false && responseData.preview_time === 0)){
              props.openSubscribeModal();
            }
      }
      else if(error!==null){
        console.log("Error data=",error);
        setState((prevState) => ({
          ...prevState,
          isJsonLoaded:true,
          isFirtLoadComplete:true,
          isLoading:false}));
          setMsgState({open:true,msg:error?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"error"});
          //if unauthorized then redirec it to login page
          if(error?.response?.status === 401 || error?.response?.status === 403){
            console.log("status received =",error?.response?.status)
            navigate(from, { replace: true });
          }
      }
      reset();
    }
    },[loaded,responseData]);

    useEffect(()=>{
      console.log("OFdata isLoading, footerloaded=",isLoading,footerLoaded,isJsonLoaded,chartData)
    },[isLoading,chartData,footerLoaded,isJsonLoaded])

    //polling or live chart update handler
    useEffect(() => {
      //set the ref to current state
      stateRef.current = state;
      
      console.log("Live use effect called incremental=",stateRef.current,stateRef.current.refreshInterval);
      const timeout = setInterval(() => {
        //if instrument is live, do fetch data based on user role else keep polling every 1min 
          let data={
            "symbol": stateRef.current.instrument,
            "nDays": 0,
            "nProf": 1,
            "liveData": true,
            "liveOnly": true,
            "startDate": "",
            "endDate": "",
            "tf": selectedTimeFrame,
            "lastTime":stateRef.current.isIncrementalData?lastTime:undefined,
            "incremental":stateRef.current.isIncrementalData?1:undefined,
            // "incremental":stateRef.current.isInstrumentLive?1:undefined
          }
           if(stateRef.current.isPollingAllowed && stateRef.current.isLivePollingAllowed)   {
             console.log("calling live of chart");
            //  cancelLive();
            executeLive(URL.OF_CHART,"POST",data); 
           } 
          
      
      }, stateRef.current.refreshInterval);

      //market status polling
      const timeoutStatusCheck=setInterval(() => {
        if(stateRef.current.isStatusCheckAllowed && !stateRef.current.isInstrumentLive && (!selectedDateTime || stateRef.current.selectedDateTimeLiveFlag))   {
           executeAPIStatus(URL.CHART_STATUS,"POST",{symbol:stateRef.current.instrument});
        }
      },stateRef.current.statusCheckPollingInterval);
    
      return () => {
        // just to clear the timeout when component unmounts
        clearInterval(timeout);
        clearInterval(timeoutStatusCheck);
      };
    }, [state]);


  /**
 * Market live status check response handler
 */  
   useEffect(() => {
    if(loadedStatus){
      if(responseDataStatus!=null){
                //if instrument is live then load the live data else set the status as per the response
                
                if(isTradingSessionActive || (responseDataStatus.isTradingSessionActive!=undefined && responseDataStatus.isTradingSessionActive)){
                  let data={
                    "symbol": stateRef.current.instrument,
                    "nDays": 0,
                    "nProf": 1,
                    "liveData": true,
                    "liveOnly": true,
                    "startDate": "",
                    "endDate": "",
                    "tf": selectedTimeFrame,
                     } 
                  executeLive(URL.OF_CHART,"POST",data); 
                }else{
                  //reload the chart once tradinng session goes from active to inactive
                  if(isPollingAllowed && isTradingSessionActive && !responseDataStatus.isTradingSessionActive){
                    console.log("RELOADING OF CHART-------> Trading session is set to false");
                    setJsonData(undefined);
                    loadData(); 
                  }
                  else{
                    setState((prevState) => ({
                      ...prevState,
                      isStatusCheckAllowed:(!responseDataStatus.isPreOpenLive),
                      statusCheckPollingInterval:(responseDataStatus.isTradingSessionActive?MP_CHART_RELOAD_TIME.FAST_POLLING:MP_CHART_RELOAD_TIME.POLLING_TIME),
                      isTradingSessionActive:responseDataStatus.isTradingSessionActive,
                      isInstrumentLive:responseDataStatus.isInstrumentLive,
                      }));
                  }
     
                }
                syncTosNotifyFromStatus(responseDataStatus, setAuth);
                syncApiNotifyFlags(responseDataStatus);
            
      }
      else if(errorStatus!==null){
        console.log("Error data status check=",errorStatus);

        // setState((prevState) => ({
        //   ...prevState,
        //   isLoading:false}));
          
          if(errorStatus?.response?.status === 401 || errorStatus?.response?.status === 403){
            console.log("status received =",errorStatus?.response?.status)
            // navigate(from, { replace: true });
            if(props.showLoginPopup){
              props.showLoginPopup(true, errorStatus);
            }
          }
      }
      resetStatus();
    }
    },[loadedStatus,responseDataStatus, setAuth]);
   
  /**
 * Live data API response handler  
 */  
   useEffect(() => {
    if(loadedLive){
      // console.log("loaded=true live",responseDataLive);
      console.log("DateTestNew live reponse=",isPollingAllowed, responseDataLive, errorLive);
      if(responseDataLive!=null && isPollingAllowed){
        if(responseDataLive.preview !== undefined) {
          setIsPreview(responseDataLive.preview);
          setPreviewTime(responseDataLive.preview_time || null);
        }
        let updateInterval=pollingInterval;
              if(responseDataLive.isPreOpenLive!=undefined && responseDataLive.isPreOpenLive){
                updateInterval=!selectedInstrumentData.slow?reloadInerval:MP_CHART_RELOAD_TIME.SLOW_DATA;
              }
            const hasOfData =
              responseDataLive.of_data !== undefined &&
              responseDataLive.of_data.length > 0;
            const hasMdata =
              responseDataLive.mdata !== undefined &&
              responseDataLive.mdata.length > 0;
            const livePayload = {
              ...responseDataLive,
              clientLivePollAt: Date.now(),
            };

            if (hasOfData || hasMdata) {
              setState((prevState) => ({
                  ...prevState,refreshInterval:updateInterval,
                  isPollingAllowed:isPollingAllowed,
                  isStatusCheckAllowed:(!responseDataLive.isPreOpenLive),
                  statusCheckPollingInterval:(responseDataLive.isTradingSessionActive?MP_CHART_RELOAD_TIME.FAST_POLLING:MP_CHART_RELOAD_TIME.POLLING_TIME),
                  isTradingSessionActive:responseDataLive.isTradingSessionActive,
                  isLoading:false,
                  isIncrementalData:hasOfData ? true : prevState.isIncrementalData,
                  isInstrumentLive:responseDataLive.isInstrumentLive,
                  isLivePollingAllowed:responseDataLive.isPreOpenLive,
                  liveData:livePayload,
                  lastTime:responseDataLive.lastTime,
                  liveDate:responseDataLive.isInstrumentLive?responseDataLive.liveDate:null,
                  liveTime:responseDataLive.isInstrumentLive?responseDataLive.lastDataTime:null,
                }));
            }
            else{
              setState((prevState) => ({
                ...prevState,refreshInterval:updateInterval,
                isPollingAllowed:isPollingAllowed,
                isStatusCheckAllowed:(!responseDataLive.isPreOpenLive),
                statusCheckPollingInterval:(responseDataLive.isTradingSessionActive?MP_CHART_RELOAD_TIME.FAST_POLLING:MP_CHART_RELOAD_TIME.POLLING_TIME),
                isTradingSessionActive:responseDataLive.isTradingSessionActive,
                isLivePollingAllowed:responseDataLive.isPreOpenLive,
                isInstrumentLive:(responseDataLive.isPreOpenLive && responseDataLive.dateList.length>0 && responseDataLive.dateList[0]==responseDataLive.liveDate)
                }));
               
            }
            if(responseDataLive.upgrade_notify!=undefined && responseDataLive.upgrade_notify && !(responseDataLive.preview === false && responseDataLive.preview_time === 0)){
              props.openSubscribeModal();
            }
      }
      else if(errorLive!==null){
        console.log("Error data live=",errorLive);
       
        setState((prevState) => ({
          ...prevState,
          isLoading:false}));
          // setMsgState({open:true,msg:error?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"error"});
          // console.log("status received =",errorLive?.response?.status)

          if(errorLive?.response?.data?.message!==null && errorLive?.response?.status === 307){
            setShowPreviewEndedPopup(true);
          }
          
          if(errorLive?.response?.status === 401 || errorLive?.response?.status === 403){
            console.log("status received =",errorLive?.response?.status)
            // navigate(from, { replace: true });
            if(props.showLoginPopup){
              props.showLoginPopup(true, errorLive);
            }
          }
          if(errorLive?.response?.status === 416){      //handle bad request in case last daya polling resumes in the next day
            window.location.reload();
          }
      }
      resetLive();
    }
    },[loadedLive,responseDataLive]);




/**
 * autoclosing of the snackbar msg bar 
 */ 
  const handleClose = (event, reason) => {
    setMsgState({...msgState,open:false});
};

const handleInstrumentChange=(instrument,tpoData,firstLoad=false,savedTPO)=>{
  // setSelectedInstrument(undefined);
  setReplayState({isReplay:false,date:null,interval:REPLAY_SPEED.DEFAULT});
  console.log("reload instrument change in orderflow =",instrument,tpoData,selectedInstrument,instrument.instr,savedTPO,firstLoad)
  if(selectedInstrument==instrument.instr && (levelData[0]!=-1 && levelData[1]!=-1)){
     console.log("reload handleInstrumentChange 1");
    // setLevelData([-1,-1]); 
    let defaultTPO=tpoData.of_default_tpo;
    // setSelectedTPO(userSettings.data.tf_tpo_map[instrument.tpo_group]!=undefined?userSettings.data.tf_tpo_map[instrument.tpo_group].daily:userSettings.data.tf_tpo_map["DEFAULT"].daily);
    defaultTPO=userSettings.data.tf_tpo_map_of!=undefined&&userSettings.data.tf_tpo_map_of[instrument.tpo_group]!=undefined?userSettings.data.tf_tpo_map_of[instrument.tpo_group].min3:defaultTPO;
    if(firstLoad==false)
      setSelectedTPO(defaultTPO);
    else 
      setSelectedTPO(savedTPO);
   
    setSelectedInstrumentTPOData(tpoData);
    setViewState({tpo_only:(userSettings.data.vp_type==VP_TYPE.NONE||userSettings.data.vp_type==VP_TYPE.BACKGROUND),vol_tpo_side:(userSettings.data.vp_type==VP_TYPE.ASIDE),only_vol:(userSettings.data.vp_type==VP_TYPE.ALONE),tpo_on_vol:(userSettings.data.vp_type==VP_TYPE.BACKGROUND)})
    setGlobalVolumeVisible(userSettings.data.show_global_vp_of!=undefined?userSettings.data.show_global_vp_of:true);
    setVolumeNumberVisible(userSettings.data.show_global_vp_numbers_of!=undefined?userSettings.data.show_global_vp_numbers_of:false);
    setTPOBasedVA(!instrument.vp || userSettings.data.va_type==VA_TYPE.TPO_BASED)
    setProfileVolumeNumberVisible(false);
    return;
  }
  // setSelectedInstrumentData(instrument);
  // if(instrument.instr!=selectedInstrument){
    if(true){
      console.log("reload handleInstrumentChange 2 globvol=",initialData?.glob_vol);
      setLevelData([-1,-1]);  
    setJsonData(undefined);
    console.log("ofdata live panel resetRightPanel===3")
    props.resetRightPanel(); 
    let tf=   jsonData!=undefined && jsonData.instrument==instrument.instr?jsonData.tf: userSettings.data.default_tf_of?userSettings.data.default_tf_of:DEFAULT_OF_TIME_FRAME;
    if(firstLoad && initialData?.tf)
      tf=initialData?.tf;
    console.log("Reload tf in first load container=",tf,initialData,initialData?.tf);
  setState((prevState) => ({
    ...prevState,
    // selectedTimeFrame:jsonData!=undefined && jsonData.instrument==instrument.instr?jsonData.tf: userSettings.data.default_tf_of?userSettings.data.default_tf_of:DEFAULT_OF_TIME_FRAME,
    selectedTimeFrame:tf,
    isLoading:true,
    isPollingAllowed:false,   //polling will start when 1st load of new instrument is done
    isStatusCheckAllowed:false,
    instrument:instrument.instr,
    chartData:undefined,
    isIncrementalData:false

  }));
  console.log("instrument change in Market profile 2 =",instrument,tpoData,selectedInstrument,instrument.instr)
  setSelectedInstrument(instrument.instr);
  if(instrument.instr==selectedInstrument)
  setToggleMPLoading(!toggleMPLoading);
    
  // setSelectedTPO(tpoData.default_tpo);
  if(jsonData!=undefined && jsonData.instrument==instrument.instr){
    // setIsDirty(false);
    setSelectedTPO(jsonData.tpo)
  }
  else{
    let defaultTPO=tpoData.of_default_tpo;
    defaultTPO=userSettings.data.tf_tpo_map_of!=undefined&& userSettings.data.tf_tpo_map_of[instrument.tpo_group]!=undefined?userSettings.data.tf_tpo_map_of[instrument.tpo_group].min3:defaultTPO;
    if(firstLoad && initialData)
      setSelectedTPO(savedTPO);
     
    else 
    setSelectedTPO(defaultTPO);
    // setSelectedTPO(defaultTPO);
    // setSelectedTPO(tpoData.of_default_tpo);
    // setSelectedTPO(0.2)
    // setSelectedTPO(userSettings.data.tf_tpo_map[instrument.tpo_group]!=undefined?userSettings.data.tf_tpo_map[instrument.tpo_group].daily:userSettings.data.tf_tpo_map["DEFAULT"].daily);
    // setIsDirty(false);
  }       
  setSelectedInstrumentTPOData(tpoData);
  // setViewState({tpo_only:true,vol_tpo_side:false,only_vol:false,tpo_on_vol:false});
  setViewState({tpo_only:(userSettings.data.vp_type==VP_TYPE.NONE||userSettings.data.vp_type==VP_TYPE.BACKGROUND),vol_tpo_side:(userSettings.data.vp_type==VP_TYPE.ASIDE),only_vol:(userSettings.data.vp_type==VP_TYPE.ALONE),tpo_on_vol:(userSettings.data.vp_type==VP_TYPE.BACKGROUND)})
 if(firstLoad && initialData){
  setGlobalVolumeVisible(initialData?.glob_vol??true);
  setVolumeNumberVisible(initialData?.glob_num??false);
  setLivePanelVisible((matches?true:false)&&(initialData?.live_panel??(userSettings.data.show_live_panel_of!=undefined?userSettings.data.show_live_panel_of:true)));
  setBottomTableVisible(initialData?.table??(userSettings.data.show_bottom_table_of!=undefined?userSettings.data.show_bottom_table_of:true));
 }
  else{
    setGlobalVolumeVisible( userSettings.data.show_global_vp_of!=undefined? userSettings.data.show_global_vp_of:true);
    setVolumeNumberVisible(userSettings.data.show_global_vp_numbers_of!=undefined?userSettings.data.show_global_vp_numbers_of:false);
    setLivePanelVisible((matches?true:false)&&(userSettings.data.show_live_panel_of!=undefined?userSettings.data.show_live_panel_of:true));
    setBottomTableVisible(userSettings.data.show_bottom_table_of!=undefined?userSettings.data.show_bottom_table_of:true);
   
  }
    // setTPOBasedVA(!instrument.vp);
  setTPOBasedVA(!instrument.vp || userSettings.data.va_type==VA_TYPE.TPO_BASED)
  setProfileVolumeNumberVisible(false);
  setSelectedInstrumentData(instrument);
}
 
  //if instrument is slow and instrument is live then then change the chart update time
}
const handleTpoChange=(val)=>{
   
  
  if(selectedTPO!=val){
    console.log("handleTPO= ",selectedTPO,val);
    console.log("live panel resetRightPanel===4")
    props.resetRightPanel(); 
    setSelectedTPO(val);
    setIsDirty(true);
  }
 
}

const changeTimeFrame=(val)=>{
window.__tfBenchmark = { tf: val, clickTime: performance.now() };
console.log(`[TF_BENCHMARK] 0.00ms | click | tf=${val}`);


  // props.resetRightPanel();  
  // if(val==selectedTimeFrame || isLoading)
  // return;
  setReplayState({isReplay:false,date:null,interval:REPLAY_SPEED.DEFAULT});
  if(selectedTimeFrame==val)
  return;
   console.log("live panel resetRightPanel===5")
  props.resetRightPanel();  
  setIsDirty(true);
  setJsonData(undefined);
console.log("Relaod time frame changed val= ==============================?",val,selectedTimeFrame,selectedTPO);
// setGlobalVolumeVisible(userSettings.data.show_global_vp);
// // setVolumeNumberVisible(false);
// setVolumeNumberVisible(userSettings.data.show_global_vp_numbers)
setGlobalVolumeVisible(userSettings.data.show_global_vp_of!=undefined? userSettings.data.show_global_vp_of:true);
setVolumeNumberVisible(userSettings.data.show_global_vp_numbers_of!=undefined?userSettings.data.show_global_vp_numbers_of:false);
setPerProfileVolumeVisible(false);
setProfileVolumeNumberVisible(false);
setLivePanelVisible((matches?true:false)&&(userSettings.data.show_live_panel_of!=undefined?userSettings.data.show_live_panel_of:true));
setBottomTableVisible((userSettings.data.show_bottom_table_of!=undefined?userSettings.data.show_bottom_table_of:true));


// setState((prevState) => ({
//   ...prevState,
//   isPollingAllowed:false,
//   isStatusCheckAllowed:false,
//   isLoading:true,
//   selectedTimeFrame:val
// }));

if(val!=TIME_FRAME_VALUES.daily){
  setLevelData([-1,-1]);
}
// console.log("Time frame change tpo vals====>",instrument.tpo_group,userSettings.data.tf_tpo_map[instrument.tpo_group],selectedInstrumentTPOData.of_tf_factor["30"],selectedInstrumentTPOData.of_tf_factor)
  //set the default tpo based on time frame selected
  let newTPO;
  if(val==OF_TIME_FRAME_VALUES.tf_1_min){
    newTPO=userSettings.data.tf_tpo_map_of!=undefined && userSettings.data.tf_tpo_map_of[selectedInstrumentData.tpo_group]!=undefined?userSettings.data.tf_tpo_map_of[selectedInstrumentData.tpo_group].min1:undefined;
  
    newTPO=newTPO?newTPO:selectedInstrumentTPOData.of_tf_factor && selectedInstrumentTPOData.of_tf_factor["1"]? selectedInstrumentTPOData.of_tf_factor["1"]*selectedInstrumentTPOData.of_default_tpo:1*selectedInstrumentTPOData.of_default_tpo;
    // setSelectedTPO(selectedInstrumentTPOData.of_tf_factor["1"]? selectedInstrumentTPOData.of_tf_factor["1"]*selectedInstrumentTPOData.of_default_tpo:1*selectedInstrumentTPOData.of_default_tpo);
    // setSelectedTPO(userSettings.data.tf_tpo_map[selectedInstrumentData.tpo_group]!=undefined?userSettings.data.tf_tpo_map[selectedInstrumentData.tpo_group].daily:userSettings.data.tf_tpo_map["DEFAULT"].daily);
  
  }
  else if (val==OF_TIME_FRAME_VALUES.tf_3_min ){
    newTPO=userSettings.data.tf_tpo_map_of!=undefined && userSettings.data.tf_tpo_map_of[selectedInstrumentData.tpo_group]!=undefined?userSettings.data.tf_tpo_map_of[selectedInstrumentData.tpo_group].min3:undefined;
    console.log("OFSETTINGS container newTPO=",newTPO)
    newTPO=newTPO?newTPO:selectedInstrumentTPOData.of_tf_factor && selectedInstrumentTPOData.of_tf_factor["3"]? selectedInstrumentTPOData.of_tf_factor["3"]*selectedInstrumentTPOData.of_default_tpo:1*selectedInstrumentTPOData.of_default_tpo;
    // setSelectedTPO(selectedInstrumentTPOData.of_tf_factor["3"]? selectedInstrumentTPOData.of_tf_factor["3"]*selectedInstrumentTPOData.of_default_tpo:1*selectedInstrumentTPOData.of_default_tpo);
      // setSelectedTPO(userSettings.data.tf_tpo_map[selectedInstrumentData.tpo_group]!=undefined?userSettings.data.tf_tpo_map[selectedInstrumentData.tpo_group].weekly:userSettings.data.tf_tpo_map["DEFAULT"].weekly);
}
else if (val==OF_TIME_FRAME_VALUES.tf_5_min ){
  newTPO=userSettings.data.tf_tpo_map_of!=undefined && userSettings.data.tf_tpo_map_of[selectedInstrumentData.tpo_group]!=undefined?userSettings.data.tf_tpo_map_of[selectedInstrumentData.tpo_group].min5:undefined;
  console.log("OFSETTINGS container newTPO=",newTPO,selectedTPO)
  newTPO=newTPO?newTPO:selectedInstrumentTPOData.of_tf_factor && selectedInstrumentTPOData.of_tf_factor["5"]? selectedInstrumentTPOData.of_tf_factor["5"]*selectedInstrumentTPOData.of_default_tpo:1*selectedInstrumentTPOData.of_default_tpo;
  // setSelectedTPO(selectedInstrumentTPOData.of_tf_factor["5"]? selectedInstrumentTPOData.of_tf_factor["5"]*selectedInstrumentTPOData.of_default_tpo:1*selectedInstrumentTPOData.of_default_tpo);
    // setSelectedTPO(userSettings.data.tf_tpo_map[selectedInstrumentData.tpo_group]!=undefined?userSettings.data.tf_tpo_map[selectedInstrumentData.tpo_group].weekly:userSettings.data.tf_tpo_map["DEFAULT"].weekly);
}
else if (val==OF_TIME_FRAME_VALUES.tf_10_min ){
  newTPO=userSettings.data.tf_tpo_map_of!=undefined && userSettings.data.tf_tpo_map_of[selectedInstrumentData.tpo_group]!=undefined?userSettings.data.tf_tpo_map_of[selectedInstrumentData.tpo_group].min10:undefined;
  
  newTPO=newTPO?newTPO:selectedInstrumentTPOData.of_tf_factor && selectedInstrumentTPOData.of_tf_factor["10"]? selectedInstrumentTPOData.of_tf_factor["10"]*selectedInstrumentTPOData.of_default_tpo:1*selectedInstrumentTPOData.of_default_tpo
  // setSelectedTPO(selectedInstrumentTPOData.of_tf_factor["10"]? selectedInstrumentTPOData.of_tf_factor["10"]*selectedInstrumentTPOData.of_default_tpo:1*selectedInstrumentTPOData.of_default_tpo);
    // setSelectedTPO(userSettings.data.tf_tpo_map[selectedInstrumentData.tpo_group]!=undefined?userSettings.data.tf_tpo_map[selectedInstrumentData.tpo_group].weekly:userSettings.data.tf_tpo_map["DEFAULT"].weekly);
}
else if (val==OF_TIME_FRAME_VALUES.tf_15_min ){
  newTPO=userSettings.data.tf_tpo_map_of!=undefined && userSettings.data.tf_tpo_map_of[selectedInstrumentData.tpo_group]!=undefined?userSettings.data.tf_tpo_map_of[selectedInstrumentData.tpo_group].min15:undefined;
  
  newTPO=newTPO?newTPO:selectedInstrumentTPOData.of_tf_factor && selectedInstrumentTPOData.of_tf_factor["15"]? selectedInstrumentTPOData.of_tf_factor["15"]*selectedInstrumentTPOData.of_default_tpo:1*selectedInstrumentTPOData.of_default_tpo;
  // setSelectedTPO(selectedInstrumentTPOData.of_tf_factor["15"]? selectedInstrumentTPOData.of_tf_factor["15"]*selectedInstrumentTPOData.of_default_tpo:1*selectedInstrumentTPOData.of_default_tpo);
    // setSelectedTPO(userSettings.data.tf_tpo_map[selectedInstrumentData.tpo_group]!=undefined?userSettings.data.tf_tpo_map[selectedInstrumentData.tpo_group].weekly:userSettings.data.tf_tpo_map["DEFAULT"].weekly);
}
else if (val==OF_TIME_FRAME_VALUES.tf_30_min ){
  newTPO=userSettings.data.tf_tpo_map_of!=undefined && userSettings.data.tf_tpo_map_of[selectedInstrumentData.tpo_group]!=undefined?userSettings.data.tf_tpo_map_of[selectedInstrumentData.tpo_group].min30:undefined;
  
  newTPO=newTPO?newTPO:selectedInstrumentTPOData.of_tf_factor && selectedInstrumentTPOData.of_tf_factor["30"]? selectedInstrumentTPOData.of_tf_factor["30"]*selectedInstrumentTPOData.of_default_tpo:1*selectedInstrumentTPOData.of_default_tpo;
  // setSelectedTPO(selectedInstrumentTPOData.of_tf_factor["30"]? selectedInstrumentTPOData.of_tf_factor["30"]*selectedInstrumentTPOData.of_default_tpo:1*selectedInstrumentTPOData.of_default_tpo);
    // setSelectedTPO(userSettings.data.tf_tpo_map[selectedInstrumentData.tpo_group]!=undefined?userSettings.data.tf_tpo_map[selectedInstrumentData.tpo_group].weekly:userSettings.data.tf_tpo_map["DEFAULT"].weekly);
}
// if(!selectedTPO)
setSelectedTPO(newTPO);
 
  setState((prevState) => ({
    ...prevState,
    isPollingAllowed:false,
    isStatusCheckAllowed:false,
    isLoading:true,
    selectedTimeFrame:val,
    isIncrementalData:false
  }));
  console.log("time frame changed val End    = ==============================?",val,selectedTimeFrame);
}

const setPollingAllowedVal=(val)=>{
  setState((prevState) => ({
    ...prevState,
    isPollingAllowed:val}));
}


const showVolumeNumber=(val)=>{
  setVolumeNumberVisible(val);
}

const setShowGlobalVolume=(val)=>{
  setGlobalVolumeVisible(val)
}

const setShowLivePanel=(val)=>{
  setLivePanelVisible(val)
}

const setShowBottomTable=(val)=>{
  setBottomTableVisible(val)
}

const showProfileVolumeNumber=(val)=>{
  setProfileVolumeNumberVisible(val);
}

const showProfileVolume=(val)=>{
  setPerProfileVolumeVisible(val)
}
const showTPOOnVolume=(val)=>{
  setTpoOnVolume(val);
}
const showOnlyVolumeProfile=(val)=>{
  setOnlyVolumeProfile(val);
}

const autocenterChart=(val)=>{
  setAutocenter(val);
}

const handleViewStateChange=(state)=>{
  setViewState(state);
  // setIsDirty(true);
}

const handleTPOBasedVA=(val)=>{
  setTPOBasedVA(val);
}

const resetChart=()=>{
setToggleReset(!toggleReset)
}

const unselectProfiles=()=>{
  console.log("unselect profile chart container");
setToggleUnselect(!toggleUnselect)
}

const setRightContainerData=(bshow,metaData,historicalData,selectedProfilesIndex,isLiveSession)=>{
  console.log("livepanel setRightContainerData show,meta,historicalData,selectedIndex,isLiveSession",bshow,metaData,historicalData,selectedProfilesIndex,isLiveSession)
  function compareNumbers(a, b) {
    return b - a;
  }
  let sortedArray=[...selectedProfilesIndex]
  sortedArray.sort(compareNumbers);
  console.log("livepanel calling MP setRightPanel");
  props.setRightPanel(bshow,metaData,historicalData,sortedArray,isLiveSession);
}

const handleVPType=(val)=>{
setVPType(val);
}

const handleFooterLoaded=()=>{
  setFooterLoaded(true);
}

const handleChartChange=(data)=>{
console.log("handleChartChange",data);
setStateData(data);
setChartType(data.data.chart_type);

}

// Add volx toggle function
const changeVolxLinesToggle=(val)=>{
  setVolxLinesToggleEnabled(val);
}

const closePreviewEndedPopup=()=>{
  setShowPreviewEndedPopup(false);
  navigate("/", { replace: true });
}

// Track pathname changes
useEffect(() => {
  const handleLocationChange = () => {
    const newPath = window.location.pathname;
    if (newPath !== currentPathname) {
      setCurrentPathname(newPath);
    }
  };

  // Listen for popstate events (back/forward navigation)
  window.addEventListener('popstate', handleLocationChange);
  
  // Also check periodically for programmatic navigation
  const interval = setInterval(handleLocationChange, 100);

  return () => {
    window.removeEventListener('popstate', handleLocationChange);
    clearInterval(interval);
  };
}, [currentPathname]);

// Update VL toggle when LVO setting changes or pathname changes
useEffect(() => {
  // Always inherit from LVO setting if available, regardless of chart type
  if (userSettings.data["lvo_visibility_ntm_volx"] !== undefined) {
    const lvoValue = userSettings.data["lvo_visibility_ntm_volx"];
    setVolxLinesToggleEnabled(lvoValue);
  } else {
    setVolxLinesToggleEnabled(false);
  }
}, [userSettings, currentPathname]);

const loadDefaultMPChart=()=>{
  console.log("OFDataLoad default mp chart start",selectedInstrument)
  // setSelectedInstrument(undefined);
  setState((prevState)=>({
    ...prevState,
    apiData:undefined,
    bookmarkData:undefined,
    instrument:undefined,
    chartData:undefined,
    isPollingAllowed:false,
    isStatusCheckAllowed:false,
    isFirtLoadComplete:false,

    // isJsonLoaded:false,
  }))
  setJsonData(undefined);
  console.log("Load default mp chart end",selectedInstrument)
  if (searchParams.has('bookmarkID') && props.val==0 && !props.isGlobalBookmark) {
    searchParams.delete('bookmarkID');
    setSearchParams({"symbol":selectedInstrument})
    // setSearchParams(searchParams);
  }
  setToggleMPLoading(!toggleMPLoading);
  // loadData();

}

useEffect(()=>{
  selectedInstrumentRef.current=selectedInstrument;
console.log("useeffect selectedinstrument",selectedInstrument,selectedInstrumentRef.current);
},[selectedInstrument])

const loadBookmark=(bookmark)=>{
  console.log("ofdata loadbookmark")
  setState((prevState)=>({
    ...prevState,
    apiData:undefined,
    bookmarkData:undefined,
    isFirtLoadComplete:false,
    isJsonLoaded:false,
    chartData:undefined,
    isPollingAllowed:false,
    isStatusCheckAllowed:false
  }))
  setIsDirty(false)
  setFooterLoaded(false)
  loadAutoSaveData(bookmark.id);
  if(props.val==0 && !props.isGlobalBookmark)
  setSearchParams({"bookmarkID": bookmark.id})
}

const deleteAutosavedBookmark=()=>{
  setOpenAutosaveDeleteDialog(false);
  const auto_saved_links=JSON.parse(localStorage.getItem('auto_saved_links'));
  const id =auto_saved_links[selectedInstrument];
  if(id!=undefined && id!=null){
    let data={
      "id": id
    }
  
    executeAPIDelete(URL.DELETE_BOOKMARK,"DELETE",data)
}

}

const cancelAutosaveDelete=()=>{
  setOpenAutosaveDeleteDialog(false)
}

const clearAutosave=()=>{
  setOpenAutosaveDeleteDialog(true);
}



//delete api response handler
useEffect(()=>{
  if(loadedDelete){
    console.log("Delete response ========>",responseDataDelete);
    if(responseDataDelete!=null){
      setMsgState({open:true,msg:`${TEXT_MSGS.CLEAR_AUTOSAVED_BOOKMARK_SUCCESS}`,severity:"success"});
      
      // let updatedData= bookmarkData.filter(item => item.id!=deletedId);
      let auto_saved_links=JSON.parse(localStorage.getItem('auto_saved_links'));
      delete auto_saved_links[selectedInstrument];
      localStorage.setItem('auto_saved_links', JSON.stringify(auto_saved_links));
      setState((prevState)=>({
        ...prevState,
        apiData:undefined,
        bookmarkData:undefined,
      }))
      setJsonData(undefined);
      
      setReloadInstrument(selectedInstrument);
      setSelectedInstrument(undefined)
 
     }else if(errorDelete!==null){
      
      if(errorDelete?.response?.status === 401 || errorDelete?.response?.status === 403){
        console.log("status received =",errorDelete?.response?.status)
        navigate(from, { replace: true });
      }else
      setMsgState({open:true,msg:error?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"error"});
    }
    resetDelete();
    
  }

},[loadedDelete,responseDataDelete])

const handleDirty=(val)=>{
  setIsDirty(val);
  console.log("OFHandleDirty",val)
  if(props.setIsDirty){
    props.setIsDirty(val);
  }
}

const updateBookmarkData=(data)=>{
  setState((prevState)=>({
    ...prevState,
    // apiData:undefined,
    bookmarkData:data,
    // isFirtLoadComplete:false,
    isJsonLoaded:true,
    // chartData:undefined,
    // isPollingAllowed:false
  }))
  setJsonData(undefined)
  
}

const showPriceTable=()=>{
  console.log("showTable=",showTable);
    setShowTable(true)
}

const showSubscribeModal=(isCustom,msg)=>{
  props.openSubscribeModal(isCustom,msg);
}



 const openSunscriptionModal=(isCustom,msg)=>{
  props.openSubscribeModal(isCustom,msg);

 }

 const openSettings=()=>{
  setShowSettings(true);
 }

 const cancelSettings=()=>{
  setShowSettings(false);
 }

 const saveSettings=(settings)=>{
  console.log("OF Settings save settings in OF chart container",settings);
  setUserSettings(settings);
 }

 useEffect(()=>{
  console.log("OF Settings useEffect called");
 },[userSettings,chartLoaded])

 useEffect(()=>{
  console.log("DateTest useEffect called in container",selectedDateTime);
 },[selectedDateTime])

 const changeSelectedDateTime=(dateTime)=>{
  setReplayState({isReplay:false,date:null,interval:REPLAY_SPEED.DEFAULT});
  if(selectedDateTime!=dateTime){
    setGlobalVolumeVisible(userSettings.data.show_global_vp_of!=undefined? userSettings.data.show_global_vp_of:true);
    setVolumeNumberVisible(userSettings.data.show_global_vp_numbers_of!=undefined?userSettings.data.show_global_vp_numbers_of:false);
    setPerProfileVolumeVisible(false);
    setProfileVolumeNumberVisible(false);
    setLivePanelVisible((matches?true:false)&&(userSettings.data.show_live_panel_of!=undefined?userSettings.data.show_live_panel_of:true));
    setBottomTableVisible((userSettings.data.show_bottom_table_of!=undefined?userSettings.data.show_bottom_table_of:true));

    setState((prevState) => ({
        ...prevState,
        isPollingAllowed:false,
        isStatusCheckAllowed:false,
        isLoading:true,
        selectedDateTime:dateTime,
        isIncrementalData:false,
        // liveData:undefined
      }));


  }
 }

 const loadLiveData=()=>{
if(selectedDateTime){
  console.log("DateTestNew loadlivedate")
  setState((prevState) => ({
    ...prevState,
    isPollingAllowed:true,
    isStatusCheckAllowed:false,
    isIncrementalData:false,
    selectedDateTimeLiveFlag:true,
  }));

  let data={
    "symbol": stateRef.current.instrument,
    "nDays": 0,
    "nProf": 1,
    "liveData": true,
    "liveOnly": true,
    "startDate": "",
    "endDate": "",
    "tf": selectedTimeFrame,
     } 
  executeLive(URL.OF_CHART,"POST",data); 
}
 }

 const changeReplayState=(isReplay,replayDate,replayInterval=REPLAY_SPEED.DEFAULT)=>{
  setReplayState({isReplay:isReplay,date:replayDate,interval:replayInterval})
 }

 const changeInterval=(interval)=>{

   setReplayState((prevState) => ({
        ...prevState,
        interval:interval}));
 }

 const changeChartDateList=(dateList)=>{
  setChartDateList(formatDatesToISO(dateList));
 }

 const changeBucket=(size)=>{
    setBucketSize(size);
 }

  useEffect(() => {
      console.log("Watchlist toggle refresh mp container", props.toggleRefresh, toggleRefresh, toggleState)
      if (toggleRefresh != undefined) {
        setStateData();
        setToggleState(!toggleState)
      }
      setToggleRefresh(props.toggleRefresh)
    }, [props.toggleRefresh])
  
  const saveState = (data) => {
    console.log("Savestate called====>")
    if (props.saveChartState)
      props.saveChartState(data);
    setInitialData(undefined);
    setTabData(undefined);
  }
  return (
    <>
     {chartType==CHART_TYPE.OF_CHART?
      <>
      {isJsonLoaded?
      <OFChartHeaderSettings initialData={initialData} chartStateData={props.chartStateData} resetRightPanel={props.resetRightPanel} userSettings={userSettings} symbol={instrument} selectedTimeFrame={selectedTimeFrame}
        instrumentChange={handleInstrumentChange} tpo={selectedTPO} tpoChange={handleTpoChange} jsonData={jsonData} bookmarkData={bookmarkData} loadDefaultMPChart={loadDefaultMPChart}
        basicUser={props.basicUser} proUser={props.proUser} saveChart={()=>setToggleSave(!toggleSave)} saveBookmark={()=>setToggleBookmark(!toggleSaveBookmark)} clearAutosave={clearAutosave}
         reloadInstrument={reloadInstrument} handleDirty={handleDirty} isDirty={isDirty} showTable={showTable} levelData={levelData} openSunscriptionModal={openSunscriptionModal}
         selectedDateTime={selectedDateTime} changeSelectedDateTime={changeSelectedDateTime} tradeDates={tradeDates} liveDate={liveDate} liveTime={liveTime} isLive={isTradingSessionActive}
         setIsDatePickerOpen={setIsDatePickerOpen} isDatePickerOpen={isDatePickerOpen} isReplay={replayState.isReplay} changeReplayState={changeReplayState} chartDateList={chartDateList} changeInterval={changeInterval}
         changeBucket={changeBucket}
         previewTime={previewTime} isPreview={isPreview} openMPChart={openMPChart}
        />
        :<></>
      }
      <div style={{paddingTop:`${CONSTANTS.FIXED_HEADER_HEIGHT}px`,width:"100%",height:"100%"}}>
       {isLoading? 
          <div  style={{textAlign:"center", width:"100%",height:"100%"}}><CircularProgress sx={{marginTop:"20%"}}/>
          </div>:
          <>
          {chartData!=undefined && footerLoaded?
          <div >
          {/* {!showTable? */}

          <OFChart showLoginPopup={props.showLoginPopup} key={props.key} val={props.val} chartScreenType={props.chartScreenType} id={props.id} chartStateData={props.chartStateData} userSettings={userSettings} liveData={liveData}
           volumeNumberVisible={volumeNumberVisible} selectedInstrumentData={selectedInstrumentData} globalVolumeVisible={globalVolumeVisible}
            selectedInstrumentTPOData={selectedInstrumentTPOData} chartData={chartData} isInstrumentLive={isInstrumentLive} 
          instrument={selectedInstrument} tpo={selectedTPO} selectedTimeFrame={selectedTimeFrame}
          setPollingAllowedVal={setPollingAllowedVal} isTradingSessionActive={isTradingSessionActive}
          profileVolumeVisible={perProfilelVolumeVisible}
          isPollingAllowed={isPollingAllowed}
          profileVolumeNumberVisible={perProfileVolumeNumberVisible}
          onlyVolumeProfile={onlyVolumeProfile}
          tpoOnVolume={tpoOnVolume}
          viewState={viewState}
          tpoBasedVA={tpoBasedVA}
          resetChart={toggleReset}  
          unselectProfiles={toggleUnselect}
          max_cmp_days={parseInt(userSettings.data.max_ndays_for_composite)}
          contracts={userSettings.data.data_in_contracts}
          locale_string={userSettings.data.number_format_locale}
          setRightContainerData={setRightContainerData}
          resetRightPanel={props.resetRightPanel}
          basicUser={props.basicUser}
          saveChart={toggleSave}
          saveBookmark={toggleSaveBookmark}
          vpType={vpType}
          bookmarkData={bookmarkData}
          handleDirty={handleDirty}
          updateBookmarkData={updateBookmarkData}
          showPriceTable={showPriceTable}
          openSubscribeModal= {showSubscribeModal}
          levelData={levelData}
          boundClass={props.boundClass}
          livePanelVisible={livePanelVisible}
          bottomTableVisible={bottomTableVisible}
          setShowLivePanel={setShowLivePanel}
          // saveChartState={props.saveChartState}
          saveChartState={(data)=>saveState(data)}
          selectedDateTime={selectedDateTime}
          tradeDates={tradeDates}
          loadLiveData={loadLiveData}
          isDatePickerOpen={isDatePickerOpen}
          replayState={replayState}
          setChartDateList={changeChartDateList}
          changeSelectedDateTime={changeSelectedDateTime}
          bucketSize={bucketSize}
          toggleRefresh={toggleRefresh}
          autoCenter={autoCenter}/>
         
         
          </div>
          :<>
          
          </>
          }
          </>
       }
        {/* <Divider orientation="vertical" sx={{width:"100%",height:'2px'}} /> 
        <MPChartRightPanel/> */}
        {!isLoading && chartData!=undefined && isJsonLoaded? 
          <OFChartFooter chartType={chartType}chartStateData={props.chartStateData} userSettings={userSettings} selectedInstrumentData={selectedInstrumentData} changeTimeFrame={changeTimeFrame}setAutocenter={autocenterChart} 
          setShowGlobalVolume={setShowGlobalVolume}  timeFrame={selectedTimeFrame}
          showVolumeNumber={showVolumeNumber}openStockChart={openStockChart}
          showPerProfileVolumeNumber={showProfileVolumeNumber}
          showPerProfilelVolume={showProfileVolume}
          showTPOOnVolume={showTPOOnVolume}
          showOnlyVolumeProfile={showOnlyVolumeProfile}
          handleViewStateChange={handleViewStateChange}
          showTPOBasedVA={handleTPOBasedVA}
          selectedInstrument={selectedInstrument}
          openLineChart={openLineChart}
          resetChart={resetChart}
          unselectProfiles={unselectProfiles}
          basicUser={props.basicUser}
          resetRightPanel={props.resetRightPanel}
          jsonData={jsonData} 
          bookmarkData={bookmarkData}
          handleVPType={handleVPType}
          handleFooterLoaded={handleFooterLoaded}
          loadBookmark={loadBookmark}
          auth={auth}
          showPriceTable={showPriceTable}
          showTable={showTable}
          handleDirty={handleDirty}
          livePanelVisible={livePanelVisible}
          setShowLivePanel={setShowLivePanel}
          bottomTableVisible={bottomTableVisible}
          setShowBottomTable={setShowBottomTable}
          openSubscribeModal= {showSubscribeModal}
          openOFChart={openOFChart}
          openMPChart={openMPChart}
          isEliteUser={isEliteUser}
          initialData={initialData}
          globalVolumeVisible={globalVolumeVisible}
          volumeNumberVisible={volumeNumberVisible}
          openSettings={openSettings}/>:
         <></>}
      </div>
        {openAutosaveDeleteDialog?
      <ConfirmActionDialog open={true} cancelHandler={cancelAutosaveDelete} saveHandler={deleteAutosavedBookmark} 
          title={TEXT_MSGS.CLEAR_AUTOSAVED_TITLE} description={TEXT_MSGS.CLEAR_AUTOSAVED_BOOKMARK}></ConfirmActionDialog>    :
      <></>
      }  
      <AppErrorPopup
        open={open}
        message={msg}
        severity={severity}
        onClose={handleClose}
        showCloseX
      />
      {/* Legacy snackbar (replaced by AppErrorPopup)
      <Snackbar onClose={handleClose} anchorOrigin={{vertical: 'top',horizontal: 'center'}} sx={{top:"48px"}} open={open} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION} >
          <Alert  severity={severity} sx={{ width:{mobile: '80%',tablet:"70%",laptop:"40%" }}}>
            {msg}
          </Alert>  
       </Snackbar>
      */}
    </>:
    <>
     {chartType==CHART_TYPE.MARKET_PROFILE && !isPreview?
      <ChartContainer tabData={tabData} saveChartState={props.saveChartState}  showLoginPopup={props.showLoginPopup} id={props.id} val={props.val}  setChartLoaded={props.setChartLoaded} boundClass={props.boundClass} chartScreenType={props.chartScreenType} setChartType={props.setChartType} chartStateData={props.chartStateData} symbol={selectedInstrument} 
      resetRightPanel={props.resetRightPanel} setRightPanel={props.setRightPanel} openSubscribeModal={props.openSubscribeModal}  basicUser={props.basicUser}  proUser={props.proUser}
      isGlobalBookmark={props.isGlobalBookmark}
          globalBookmarkData={props.globalBookmarkData}
          toggleRefresh={toggleRefresh}
          setIsDirty={props.setIsDirty}>
       
     {/* <ChartContainer  id={props.id} val={props.val} boundClass={props.boundClass} setChartType={props.setChartType} setCurrentChartType={setCurrentChartType}chartStateData={props.chartStateData} symbol={selectedInstrument} 
     resetRightPanel={props.resetRightPanel} chartScreenType={props.chartScreenType} setRightPanel={props.setRightPanel} chartType={chartType} openSubscribeModal={props.openSubscribeModal}  basicUser={props.basicUser}  proUser={props.proUser}> */}
      
     </ChartContainer>:
     <></>
    }
    {chartType==CHART_TYPE.LINE_CHART?
    // <LineChart id={props.id} val={props.val} stateData={stateData} symbol={selectedInstrument} nDays={userSettings.data.default_lc_ndays}></LineChart>
    <>
    {isEliteUser?
     <LineChartContainerNew
     key={0}
     val={props.val}
     id={props.id}
     symbol={selectedInstrument}
     nDays={userSettings.data.default_lc_ndays}
     boundClass={props.boundClass}
     setChartType={props.setChartType}
     resetRightPanel={props.resetRightPanel}
     setRightPanel={props.setRightPanel}
     chartScreenType={props.chartScreenType}
     basicUser={props.basicUser}
     openSubscribeModal={props.openSubscribePropModal} 
     // openSubscribePropModal={showSubscribeProModal}
     proUser={props.proUser}
     chartStateData={props.chartStateData}
     stateData={stateData}
     setChartLoaded={props.setChartLoaded}
     saveChartState={props.saveChartState}
     tabData={tabData}
     isGlobalBookmark={props.isGlobalBookmark}
     globalBookmarkData={props.globalBookmarkData}
     setIsDirty={props.setIsDirty}
     toggleRefresh={toggleRefresh}
     volxLinesToggleEnabled={volxLinesToggleEnabled}
     changeVolxLinesToggle={changeVolxLinesToggle}

   />:
    <LineChartContainer
    key={0}
    val={props.val}
    id={props.id}
    symbol={selectedInstrument}
    nDays={userSettings.data.default_lc_ndays}
    boundClass={props.boundClass}
    setChartType={props.setChartType}
    resetRightPanel={props.resetRightPanel}
    setRightPanel={props.setRightPanel}
    chartScreenType={props.chartScreenType}
    basicUser={props.basicUser}
    openSubscribeModal={props.openSubscribePropModal} 
    // openSubscribePropModal={showSubscribeProModal}
    proUser={props.proUser}
    chartStateData={props.chartStateData}
    stateData={stateData}
    setChartLoaded={props.setChartLoaded}
    saveChartState={props.saveChartState}
    tabData={tabData}
    isGlobalBookmark={props.isGlobalBookmark}
          globalBookmarkData={props.globalBookmarkData}
          setIsDirty={props.setIsDirty}
  ></LineChartContainer>
    }
    </>
    :
    <></>}
    {chartType==CHART_TYPE.HV_CHART?
    <StockChartHV id={props.id} stateData={stateData} symbol={selectedInstrument} nDays={userSettings.data.default_lc_ndays}></StockChartHV>:
    <></>}
     {chartType==CHART_TYPE.BAR_CHART?
    // <BarChart id={props.id} stateData={stateData} symbol={selectedInstrument} nDays={userSettings.data.default_lc_ndays}></BarChart>
    <BarChartContainer
    key={0}
    val={props.val}
    id={props.id}
    symbol={selectedInstrument}
    nDays={userSettings.data.default_lc_ndays}
    boundClass={props.boundClass}
    setChartType={props.setChartType}
    resetRightPanel={props.resetRightPanel}
    setRightPanel={props.setRightPanel}
    chartScreenType={props.chartScreenType}
    basicUser={props.basicUser}
    openSubscribeModal={props.openSubscribePropModal} 
    // openSubscribePropModal={showSubscribeProModal}
    proUser={props.proUser}
    chartStateData={props.chartStateData}
    stateData={stateData}
    setChartLoaded={props.setChartLoaded}
    saveChartState={props.saveChartState}
    tabData={tabData}
    isGlobalBookmark={props.isGlobalBookmark}
          globalBookmarkData={props.globalBookmarkData}
          setIsDirty={props.setIsDirty}
  />
    :
    <></>}
     {chartType!=CHART_TYPE.MARKET_PROFILE && chartType!=CHART_TYPE.LINE_CHART && chartType!=CHART_TYPE.BAR_CHART?
    <MPChartFooter chartType={chartType} chartStateData={props.chartStateData} userSettings={userSettings} selectedInstrumentData={selectedInstrumentData} changeTimeFrame={changeTimeFrame}setAutocenter={autocenterChart} 
          setShowGlobalVolume={setShowGlobalVolume}  timeFrame={selectedTimeFrame}
          showVolumeNumber={showVolumeNumber}openStockChart={openStockChart}
          showPerProfileVolumeNumber={showProfileVolumeNumber}
          showPerProfilelVolume={showProfileVolume}
          showTPOOnVolume={showTPOOnVolume}
          showOnlyVolumeProfile={showOnlyVolumeProfile}
          handleViewStateChange={handleViewStateChange}
          showTPOBasedVA={handleTPOBasedVA}
          selectedInstrument={selectedInstrument}
          openLineChart={openLineChart}
          basicUser={props.basicUser}
          handleVPType={handleVPType}
          handleFooterLoaded={handleFooterLoaded}
          handleChartChange={handleChartChange}
          auth={auth}
          showPriceTable={showPriceTable}
          showTable={showTable}
          openSubscribeModal= {showSubscribeModal}
         openOFChart={openOFChart}
          openMPChart={openMPChart}/>
          :
          <></>
     }
    </>
    }   

     {showSettings?
     <OFSettings open={true} proUser={props.proUser} selectedInstrumentData={selectedInstrumentData} instrument={selectedInstrument} cancelHandler={cancelSettings} saveHandler={saveSettings} ></OFSettings>    :
     <></>
    }
    {showPreviewEndedPopup?
     <PreviewEndModal open={true} onClose={closePreviewEndedPopup} ></PreviewEndModal>    :
     <></>
    }
    </>
       
   
   
  )
}

export default OrderflowContainer

